<script setup lang="ts">
withDefaults(defineProps<{ kind?: 'actions' | 'tabs' | 'composer' }>(), { kind: 'actions' })
</script>

<template>
  <!-- Place in PageLayout's #fixed slot: it sits below the scrolling body. -->
  <div class="page-footer" :class="`page-footer-${kind}`">
    <div class="shell-user"><slot /></div>
  </div>
</template>

<style scoped>
.page-footer {
  position: relative;
  z-index: 30;
  flex: none;
  border-top: 1px solid var(--app-bars-border-color);
  background: var(--app-bars-bg-color);
  padding: 12px 16px max(12px, env(safe-area-inset-bottom));
}
.page-footer-tabs {
  padding: 0 16px env(safe-area-inset-bottom);
}
.page-footer-composer {
  padding: 0 0 max(12px, env(safe-area-inset-bottom));
}
</style>
